const InstructionController = require('InstructionController');
const LoadingBetController = require('LoadingBetController');
const GenericUI = require('GenericUI').ui;
const GameScene = require('GameScene');
const AudioMap = require('AudioMap');
const SlotUI = require('SlotUI');
const PSState = require('PSState');
const PSEvents = require('PSEvents');

cc.Class({
    extends: cc.Component,

    properties: {
        gameScene: GameScene,
        logo: cc.Node,
        buttonsContainer: cc.Node,
        loadingBetController: LoadingBetController,
        playSpine: sp.Skeleton,
        playButton: cc.Button,
        infoButton: cc.Button,
        sellups: InstructionController
    },

    onLoad () {
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);
        this.resizeManager = cc.find('ResizeManager').getComponent('ResizeManager');
        this.isLandscape = true;

        PSEvents.getLastOrSubscribe(PSEvents.WIN_RESTORE_RESPONSE, (data) => {
            this.onPlayClicked();
        }, this);
    },

    onDestroy () {
        PSEvents.removeAllListenerByTarget(this);
        GenericUI.unregisterKeyboardHandler(this.keyboardEnterHandler);
        this.resizeManager.removeNode(this);
    },

    onViewResize () {
        this.screenRect = cc.view.getVisibleSize();
        const aspect = this.screenRect.width / this.screenRect.height;

        if (this.isLandscape && aspect < .8) {
            this._portaitDesign();
        }
        if (aspect >= .8) {
            this._landscapeDesign(aspect);
        }
    },

    _portaitDesign () {
        this.isLandscape = false;
        if (this.isAnimated) {
            this.logo.setPosition(0, 300);
        }
    },

    _landscapeDesign () {
        this.isLandscape = true;
        if (this.isAnimated) {
            this.logo.setPosition(0, 200);
        }

    },

    start () {
        const isSkip =  SlotUI.isReplayMode() || PSState.get().isExitReplay;
        const inheretedLogo = cc.find('logoSpine');

        if (isSkip) {

            if (inheretedLogo) {
                inheretedLogo.destroy();
            }

            this.skipIntro();
            return;
        }

        this.resizeManager.appendNode(this);


        if (inheretedLogo) {
            inheretedLogo.setParentKeepPosition(this.logo);
            inheretedLogo.scale = 0.5;
        }

        this.inheretedLogo = inheretedLogo;

        this.playButton.interactable = false;
        this.infoButton.interactable = false;

        this.buttonsContainer.scaleX = 0.5;
        this.buttonsContainer.scaleY = 0;
        this.isAnimated = false;
        this.onViewResize();
        const logoY = this.isLandscape? 200: 300;
        cc.tween(this.logo).delay(0.5).by(0.4, { y: logoY }, { easing: 'backOut' }).
            call(() => {
                this.isAnimated = true;
            }).
            start();
        cc.tween(this.buttonsContainer).
        delay(0.5).
        to(0.4, { scaleX: 1, scaleY: 1 }, { easing: 'backOut' }).
        call(this.showed, this).
        start();

        this.playSpine.setAnimation(0, 'idle', true);
        // this.sellups.hide();
    },

    showed () {
        this.playButton.interactable = true;
        this.infoButton.interactable = true;

        GenericUI.enableCUIKeyboardKeys(false, ['Esc']);
        GenericUI.enableCUIKeyboard();
        this.keyboardEnterHandler = () => this.onPlayClicked();
        GenericUI.registerKeyboardHandler(['Space', 'Enter'], this.keyboardEnterHandler);
    },

    onPlayClicked () {
        const isSkip = SlotUI.isReplayMode();

        if (isSkip) {
            this.skipIntro();
            return;
        }

        const musicId = this.audioMap.playSfx('IntroPlay');
        this.playSpine.setAnimation(0, 'match', true);
        this.playSpine.addAnimation(0, 'idle', true);
        this.playButton.interactable = false;
        this.infoButton.interactable = false;
        this.loadingBetController.disable();

        GenericUI.unregisterKeyboardHandler(this.keyboardEnterHandler);
        GenericUI.enableCUIKeyboard(false);

        this.scheduleOnce(() => {
            this.gameScene.showScene();
        }, 0.3);

        this.scheduleOnce(() => {
            this.node.destroy();
        }, 3);
    },

    skipIntro() {
        this.playButton.interactable = false;
        this.infoButton.interactable = false;
        this.loadingBetController.disable();

        GenericUI.unregisterKeyboardHandler(this.keyboardEnterHandler);
        GenericUI.enableCUIKeyboard(false);

        this.gameScene.showSceneImmediate();

        this.scheduleOnce(() => {
            this.node.destroy();
        }, 0)
    },

    onInfoClicked () {

    },
});
